import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { PasswordService } from '../services/PasswordService';

@Component({
    selector: 'user-set-new-password',
    template: require('./SetNewPasswordComponent.html'),
    styles: [require('./SetNewPasswordComponent.sass')],
})

export class SetNewPasswordComponent implements OnInit {
    message: string;
    messageType: string;
    private redirectUrl = "hol-login";
    private newPassword: string;
    private confirmNewPassword: string;

    private formSubmitted: boolean = false;
    private token: string;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private passwordService: PasswordService
    ) { }
    
    ngOnInit() {
        // Get token string from URL.
        this.route.params.forEach((params: Params) => {
            this.token = params['token'];
        });
        
        // Verify if token is valid or not.
        this.verifyToken();
    }

    // Called when user submit form
    onSubmit() {
        // Mark form as submitted to disable submit button
        this.formSubmitted = true;
        
        // Reset form alert message 
        this.message = "";
        this.messageType = "";

        // Process set new password
        this.setNewPassword(this.token, this.newPassword);
    }

    // Verify reset password token with servie
    private verifyToken() {
        this.passwordService.verifyPasswordResetToken(this.token)
            .subscribe(
                complete => {
                    this.formSubmitted = false;
                },
                error => {
                    // Set message type as error and message error content
                    this.message = "Token not found or expired.";
                    this.messageType = "alert";
                    // Set form as submitted to prevent user post their new password
                    this.formSubmitted = true;
                }
            );
    }

    // Set new password with new password input and verified token
    private setNewPassword(token: string, newPassword: string) {
        this.passwordService.setPasswordWithResetToken(token, newPassword)
            .subscribe(
                    complete => {
                        // Update message on success
                        this.message = "Changed password successfully. You will be redirected to Login Page in 5 seconds.";
                        this.messageType = "success";
                        
                        // Delay 5s before redirect to login page
                        setTimeout( () => {
                            this.redirect(this.redirectUrl);
                        }, 5000);
                    },
                    error => {
                        // Set message type as error and error message content
                        this.message = "There is an issue when setting new password.";
                        this.messageType = "alert";
                        // Reset form submit status
                        this.formSubmitted = false;
                    }
            );
    }

    // Redirect to desired url
    private redirect(url: string) {
        this.router.navigate([this.redirectUrl]);
    }
}


// WEBPACK FOOTER //
// ./src/common/modules/user/forgot-password/SetNewPasswordComponent.ts